import Repository from '../../../Repository';

const resource = '/shopify';

export default {
  createRefund(region, orderId, refund) {
    return Repository.post(`${resource}/${orderId}/refunds`, {
      region,
      refund,
    });
  },
  calculateRefund(region, orderId, refund, draftOrder) {
    return Repository.post(`${resource}/${orderId}/refunds/calculate-refund`, {
      region,
      refund,
      draftOrder
    });
  },
  calculateRefundDifference(region, orderId, {original_order, updated_order}) {
    return Repository.post(
        `${resource}/${orderId}/refunds/calculate-refund-difference`, {
          region,
          original_order,
          updated_order,
        });
  },
};
